import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import withSelectedDeviations from '../../_hocs/withSelectedDeviations';
import { withMobileContext } from '../../../Context';
import s from './SelectedItemsPanel.scss';
var enhance = compose(withSelectedDeviations, withMobileContext, withTranslation());
var SelectedItemsPanel = /** @class */ (function (_super) {
    __extends(SelectedItemsPanel, _super);
    function SelectedItemsPanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectedItemsPanel.prototype.render = function () {
        var _a = this.props, t = _a.t, selectedCount = _a.selectedCount, selectionLimit = _a.selectionLimit, showSelectionLimit = _a.showSelectionLimit, extras = _a.extras, extrasClassName = _a.extrasClassName, isMobile = _a.isMobile;
        if (selectedCount < 1 || selectionLimit === 1 || isMobile) {
            return null;
        }
        return (React.createElement("div", { className: s['root'] },
            React.createElement("div", { className: s['numbers'] },
                React.createElement("span", { className: s['selected-count'] }, t('mediapopup.selectedCount', { count: selectedCount })),
                showSelectionLimit && (React.createElement("span", { className: s['selected-count-of-max-count'] }, t('mediapopup.selectedCountOfSelectionMax', {
                    selectedCount: selectedCount,
                    selectionLimit: selectionLimit,
                })))),
            React.createElement("div", { className: classnames(s['extras'], extrasClassName) }, extras)));
    };
    SelectedItemsPanel.defaultProps = {
        showSelectionLimit: true,
    };
    return SelectedItemsPanel;
}(React.Component));
export { SelectedItemsPanel };
export default enhance(SelectedItemsPanel);
//# sourceMappingURL=SelectedItemsPanel.connected.js.map